import React from "react";
import { useTranslation } from "react-i18next";
import {
  Stack,
  Title,
  Text,
  Grid,
  Box,
} from "@mantine/core";
import { CardMyCollection } from "./Card/CardMyCollection";
import MyCollectionToolbar from "./MyCollectionToolbar";

const MyCollectionListSection = ({
  isMobile,
  myCollections,
  aggregationType,
  sortMetric,
  handleAggregationTypeChange,
  handleSortMetricChange,
}) => {
  const { t } = useTranslation();
  


  return (
    <Stack gap={24}>
      <Title order={3}>{t("myCollection.myCollection")}</Title>
      <MyCollectionToolbar
        aggregationType={aggregationType}
        onAggregationChange={handleAggregationTypeChange}
        sortMetric={sortMetric}
        onSortChange={handleSortMetricChange}
      />
      {myCollections.length === 0 ? (
        <Text c="dimmed" fz="sm" ta="center" py="xl">
          {t("myCollection.empty")}
        </Text>
      ) : (
        <Grid gutter="md">
          {myCollections.map((collection, index) => (
            <Grid.Col
              key={`${collection.id || index}-grid`}
              span={isMobile ? 6 : 4}
            >
              <Box h="100%">
                <CardMyCollection
                  collection={collection}
                  isMobile={isMobile}
                  isMe={true}
                  style={{ height: "100%" }}
                />
              </Box>
            </Grid.Col>
          ))}
        </Grid>
      )}
    </Stack>
  );
};

export default MyCollectionListSection;
